function r(n) {
  return n != null && typeof n == "object";
}
function l(n, s) {
  const t = Object.keys(n), e = Object.keys(s);
  if (t.length !== e.length)
    return !1;
  for (const f of t) {
    const o = n[f], c = s[f], i = r(o) && r(c);
    if (i && !l(o, c) || !i && o !== c)
      return !1;
  }
  return !0;
}
function u(n, ...s) {
  if (!s.length) return n;
  const t = s.shift();
  if (r(n) && r(t))
    for (const e in t)
      r(t[e]) ? (n[e] || Object.assign(n, { [e]: {} }), u(n[e], t[e])) : Object.assign(n, { [e]: t[e] });
  return u(n, ...s);
}
function y(n, s) {
  const t = s.split(".");
  let e = n;
  for (const f of t) {
    if (e === null || typeof e != "object" || !(f in e))
      return !1;
    e = e[f];
  }
  return !0;
}
export {
  l as deepEqual,
  y as hasKey,
  r as isObject,
  u as mergeDeep
};
